import React, { useCallback, useState } from 'react';
import { useDispatch, } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setLanguage } from '@/shared/actions';
import { getLanguage } from '@/services/GNRL';
import { translate } from '@/services/TranslationService';
import {
    NovovilleButton,

    Typography,
} from '@/components/novoville';
import {
    Card,
    CardContent,
    CardDescription,

    CardHeader,
    CardTitle,
} from '@/components/ui/card';
import '../../output.css';
import AuthPageContainer from '../auth/AuthPageContainter';
import { ArrowRight } from 'lucide-react';


const Divider = () => (
  <div className="flex items-center gap-3 text-gray-500">
    <div className="h-px bg-gray-200 flex-1" />
    <Typography variant="regular_12">
      {translate('PublicPaymentsDividerOr')}
    </Typography>
    <div className="h-px bg-gray-200 flex-1" />
  </div>
);

const PublicPaymentAccess = ({ history }) => {


    const initialLanguage = getLanguage();
    const dispatch = useDispatch();

    const [selectedLanguage, setSelectedLanguage] = useState(
        initialLanguage || ''
    );

    const handleLanguageChange = async (newLanguage) => {
        setSelectedLanguage(newLanguage);
        await dispatch(setLanguage(newLanguage));
    };

    const navigate = useCallback(
        (path) => {
            history.push(path);
        },
        [history]
    );

    const navigateToHello = useCallback(() => {
        history.push('/hello');
    }, [history]);

    const navigateToPayments = useCallback(() => {
        history.push('/payments');
    }, [history]);

    return (
        <AuthPageContainer
            language={selectedLanguage}
            handleLanguageChange={handleLanguageChange}
        >
            <Card className="h-full w-full sm:p-[30px] sm:drop-shadow-md drop-shadow-none shadow-none text-gray-800 px-[24px] border-none max-w-lg!">
            <CardHeader className="text-center p-0 ">
              <CardTitle className="text-3xl ">
                <Typography variant="bold_24" className="text-center text-gray-800 mb-8">
                  {translate('PublicPaymentsTitle')}
                </Typography>
              </CardTitle>
              <CardDescription className="mt-0">

              </CardDescription>
            </CardHeader>
                <CardContent className="my-4 p-0 flex flex-col space-y-4">
                    <div className="flex flex-col gap-6">
                <section className="rounded-md text-center">
                  <Typography variant="semibold_18" className="text-gray-800">
                    {translate('PublicPaymentsHaveAccountTitle')}
                  </Typography>
                  <Typography variant="regular_14" className="text-gray-600 mt-2">
                    {translate('PublicPaymentsHaveAccountBody')}
                  </Typography>
                  <NovovilleButton
                    variant="primary"
                    className="w-full mt-5"
                    onClick={navigateToHello}
                  >
                    {translate('PublicPaymentsLoginBtn')}
                  </NovovilleButton>
                </section>

                        <Divider />

                <section className=" rounded-mdtext-center">
                  <Typography variant="semibold_18" className="text-gray-800">
                    {translate('PublicPaymentsNewTitle')}
                  </Typography>
                  <Typography variant="regular_14" className="text-gray-600 mt-2">
                    {translate('PublicPaymentsNewBody')}
                  </Typography>
                  <NovovilleButton
                    variant="outline"
                    className="w-full mt-5"
                    onClick={navigateToHello}
                  >
                    {translate('PublicPaymentsCreateAccountBtn')}
                  </NovovilleButton>
                </section>

                        <Divider />

                <section className="rounded-md px-5 py-6 text-center">
                  <Typography variant="semibold_18" className="text-gray-800">
                    {translate('PublicPaymentsJustPayTitle')}
                  </Typography>
                  <Typography variant="regular_14" className="text-gray-600 mt-2">
                    {translate('PublicPaymentsJustPayBody')}
                  </Typography>
                  <button
                    type="button"
                    onClick={() => navigate('/public/payments')}
                    className="mt-5 inline-flex items-center justify-center text-sm font-semibold text-gray-800 hover:text-black"
                  >
                    {translate('PublicPaymentsContinueBtn')}
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </button>
                </section>
                    </div>
                </CardContent>

            </Card>
        </AuthPageContainer >
    );
};

export default withRouter(PublicPaymentAccess);
